import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FilledLinkToWebField } from '@prismicio/client';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { AnalyticsService } from 'analytics';
import { BrandService } from 'brand';
import { CurvedBoxComponent } from 'curved-box';
import { SvgComponent } from 'icon';
import { Promotion } from 'interfaces';
import { LinkComponent } from 'link';
import { OfferBoxButtonComponent, OfferBoxComponent, OfferBoxCountDownComponent } from 'offer-box';
import { OfferBoxLightComponent } from 'offer-box-light';
import { PCProduct } from 'product';
import { HeroAreaSlice } from './hero-area.slice';

@Component({
  selector: 'app-hero-area',
  templateUrl: './hero-area.component.html',
  styleUrls: ['./hero-area.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    NgClass,
    LinkComponent,
    SvgComponent,
    DynamicHooksModule,
    NgFor,
    OfferBoxCountDownComponent,
    OfferBoxButtonComponent,
    OfferBoxComponent,
    OfferBoxLightComponent,
    CurvedBoxComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroAreaComponent {
  brand = inject(BrandService);
  private analytics = inject(AnalyticsService);
  @Input() slice: HeroAreaSlice;

  onButtonClick() {
    if ((this.slice.button_link as FilledLinkToWebField)?.url?.includes('/tv-free')) {
      const data = {
        event: 'gtm visitor interaction',
        interaction_name: 'free tv click',
        free_tv_step: 'from tv to tv-free page',
      };
      this.analytics.customEvent(data);
    }
  }

  onOfferClick({ product, promotion }: { product: PCProduct; promotion: Promotion }) {
    this.analytics.addECommerceEvent('add_to_cart', product, promotion);
  }
}
